import React, { useState, useEffect, useRef } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import io from 'socket.io-client';
import Timer from 'react-timer-wrapper';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import { Modal } from 'react-responsive-modal';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { Base64 } from 'js-base64';
// import CryptoJS from 'crypto-js';
import '../css/yemae.css';

import SeatReserveMy from './SeatReserveMy';
// import { useBeforeunload } from 'react-beforeunload';
// const customCharset =
//   'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
let socket;
// const socket = io('http://son.aniplustv.com:4000');

// ➔ 기본 Base64 → 커스텀 Base64로 변환
// const base64ToCustom = (base64Str) =>
//   base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

// ➔ 커스텀 Base64 → 기본 Base64로 되돌리기
// const customToBase64 = (customStr) => {
//   let base64 = customStr.replace(/-/g, '+').replace(/_/g, '/');
//   while (base64.length % 4) base64 += '=';
//   return base64;
// };

const SeatReserve = (props) => {
  const { apiUrl, loginId, nicName, history, pkg, icon } = props;
  const { leaveQueue, leaveReservation } = props.childProps;
  const [ticketInfo, setTicketInfo] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [timeInfo, setTimeInfo] = useState([]);
  const [screenInfo, setScreenInfo] = useState([]);
  const [ticketCode, setTicketCode] = useState(0);

  const [ticketDateCode, setTicketDateCode] = useState(0);
  const [ticketDateName, setTicketDateName] = useState('');

  const [ticketTimeCode, setTicketTimeCode] = useState(0);
  const [ticketTimeName, setTicketTimeName] = useState('');

  const [ticketScreenCode, setTicketScreenCode] = useState('');
  const [ticketScreenName, setTicketScreenName] = useState('');

  const [ticketGrade, setTicketGrade] = useState('');

  const [ticketPrice, setTicketPrice] = useState(0);
  const [ticketSumPrice, setTicketSumPrice] = useState(0);

  const [seatNumber, setSeatNumber] = useState(0);
  const [remainSeat, setRemainSeat] = useState(0);

  const [ticketCount, setTicketCount] = useState(0);

  const [payType, setPayType] = useState('');

  const [step, setStep] = useState(1);
  const [mm, setMm] = useState('');
  const [ss, setSs] = useState('');

  const [mySeats, setMySeats] = useState([]);

  const [listShow, setListShow] = useState(false);

  const [payPopup, setPayPopup] = useState(false);

  const [seats, setSeats] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  //타이머
  const [remainingTime, setRemainingTime] = useState(
    loginId === 'admin' || loginId === 'aniplus' ? 20 * 60 : 5 * 60
  );
  const startTimeRef = useRef(Date.now());

  const crypKey = 'aniplusToJjmwSkey0522';

  const timerDuration = loginId === 'admin' ? 1000 * 60 * 50 : 1000 * 60 * 5;
  let worker;
  // if (loginId) {
  //   // const base64Encoded = Base64.encode(loginId);
  //   // const customEncoded = base64ToCustom(base64Encoded);
  //   // console.log('Custom Base64:', customEncoded);

  //   // const recoveredBase64 = customToBase64(customEncoded);
  //   // const decodedText = Base64.decode(recoveredBase64);
  //   // console.log('Decoded Text:', decodedText);
  //   // const e = base64Toencode(loginId);
  //   // console.log(e);
  //   // const d = base64Todecode(e);
  //   // console.log(d);
  //   // const crypId = CryptoJS.AES.encrypt(loginId, crypKey).toString();
  //   // console.log(crypId);
  //   // const bytes = CryptoJS.AES.decrypt(crypId, crypKey);
  //   // const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  //   // console.log(decrypted);
  // }

  // useBeforeunload((event) => {
  //   event.preventDefault();
  // });

  const initSocket = (rtime) => {
    // console.log(rtime);
    // socket = io('http://son.aniplustv.com:4000');
    if (rtime === 1000) {
      // socket = io('https://ticket1.aniplustv.com');
      socket = io('https://ticket1.aniplustv.com');
    } else if (rtime === 1245) {
      socket = io('https://ticket2.aniplustv.com');
    } else if (rtime === 1520) {
      //socket = io('https://ticket3.aniplustv.com');
    }

    // console.log(socket);

    socket.on('seatStatus', (s) => {
      // console.log(seats);
      setSeats(s);
      // console.log(seats);
    });

    socket.on('loginFailed', (message) => {
      alert(message);
      setIsLoggedIn(false);
    });
    // 예약 실패 메시지 수신
    socket.on('reservationFailed', (message) => {
      alert(message);
      if (message === '이미 접속된 계정입니다.') {
        if (worker) {
          worker.terminate();
        }

        leaveReservation();
        if (socket) {
          socket.off('seatStatus');
          socket.off('loginFailed');
          socket.off('reservationFailed');
          socket.off('seatSuccess');
          socket.off('disconnectUpdate');
          socket.off('seatUpdate');
          socket.off('payUpdate');
          socket.off('cancelUpdate');
          socket.disconnect();
        }
        window.location.href = '/event/352';
      }
    });

    socket.on('seatSuccess', (data) => {
      if (data.type === 'add') {
        // setMySeats((prev) => [...prev, data.seatName]);
        mySeats.push(data.seatName);
        setMySeats(mySeats.toString());
      } else if (data.type === 'remove') {
        const pos = mySeats.indexOf(data.seatName);
        mySeats.splice(pos, 1);
        setMySeats(mySeats.toString());
      }
    });
    socket.on('disconnectUpdate', async (data) => {
      setSeats((prevSeats) => {
        const updateSeats = [...prevSeats];
        data.forEach((item) => {
          updateSeats[item.y][item.x].r = 1;
          updateSeats[item.y][item.x].i = '';
        });
        return updateSeats;
      });
    });
    socket.on('seatUpdate', async (data) => {
      const { type, x, y, seatName, ui } = data;
      // console.log(type, x, y, seatName, userid);
      if (type === 'add') {
        setSeats((prevSeats) => {
          const updateSeats = [...prevSeats];
          if (updateSeats[y][x].r === 1 && updateSeats[y][x].i === '') {
            updateSeats[y][x].i = ui;
            updateSeats[y][x].r = 2;
            return updateSeats;
          }
        });
      } else if (type === 'remove') {
        setSeats((prevSeats) => {
          const updateSeats = [...prevSeats];
          // console.log(updateSeats[y][x].i, userid);
          if (updateSeats[y][x].r === 2 && updateSeats[y][x].i === ui) {
            updateSeats[y][x].i = '';
            updateSeats[y][x].r = 1;
            return updateSeats;
          }
        });
      } else {
        // console.log('error...');
      }
    });
    socket.on('payUpdate', async (obj) => {
      const { data } = obj;
      setSeats((prevSeats) => {
        const updateSeats = [...prevSeats];
        data.map((item) => {
          updateSeats[item.y][item.x].r = 3;
          updateSeats[item.y][item.x].i = item.ui;
        });
        return updateSeats;
      });
    });
    socket.on('cancelUpdate', async (obj) => {
      const { data } = obj;
      setSeats((prevSeats) => {
        const updateSeats = [...prevSeats];
        data.map((item) => {
          if (
            (updateSeats[item.y][item.x].r =
              3 && updateSeats[item.y][item.x].i === item.ui)
          ) {
            updateSeats[item.y][item.x].r = 1;
            updateSeats[item.y][item.x].i = '';
          }
        });
        return updateSeats;
      });
    });
  };

  const _getInfo = async () => {
    const result = await axios.post(`${apiUrl}/seatReserveGetTicket`, {
      userid: loginId,
    });
    const intReturn = result.data[0].intReturn;
    console.log(result.data[0]);
    if (intReturn === 0) {
      setTicketInfo(result.data[0].listData);
      setUserInfo(result.data[0].userData);
      setTicketCode(result.data[0].listData[0].ticketCode);
    } else {
      setTicketInfo([]);
      setUserInfo([]);
      setTicketCode(0);
      setTicketPrice(0);
      setTicketSumPrice(0);
      setSeatNumber(0);
      setRemainSeat(0);

      setTicketDateCode(0);
      setTicketDateName('');

      setTicketTimeCode(0);
      setTicketTimeName('');

      setTicketScreenCode('');
      setTicketScreenName('');

      setTicketGrade('');
      if (intReturn === -1) {
        history.push('/event/352');
        setTimeout(() => {
          alert('예매가 진행중인 상영회가 없습니다.');
        }, 500);

        // history.goBack();
      } else if (intReturn === -2) {
        history.push('/event/352');
        setTimeout(() => {
          alert('예매가 시작전이거나 종료되었습니다.');
        }, 500);

        // history.goBack();
      }
    }
  };

  const _getTimeInfo = async (code) => {
    // console.log(ticketCode);
    const result = await axios.post(`${apiUrl}/seatReserveGetTime`, {
      ticketCode,
      ticketDateCode: code,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setTimeInfo(result.data[0].listData);
    } else {
      setTimeInfo([]);
    }
  };

  const _getScreenInfo = async (code) => {
    // console.log(ticketCode, ticketDateCode, code);
    const result = await axios.post(`${apiUrl}/seatReserveGetScreen`, {
      ticketCode,
      ticketDateCode,
      ticketTimeCode: code,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setScreenInfo(result.data[0].listData);
    } else {
      setScreenInfo([]);
    }
  };

  const _changeDate = (e) => {
    const ticketDateCode = parseInt(e.target.value);
    const ticketDateName = e.target.options[e.target.selectedIndex].text;
    // console.log(ticketInfo[e.target.selectedIndex - 1].ticketPrice);

    _getTimeInfo(ticketDateCode);

    setTicketDateCode(ticketDateCode);
    setTicketDateName(ticketDateName);
    setTicketPrice(ticketInfo[e.target.selectedIndex - 1].ticketPrice);

    setTicketSumPrice(0);
    setSeatNumber(0);
    setRemainSeat(0);

    setTicketTimeCode(0);
    setTicketTimeName('');

    setTicketScreenCode('');
    setTicketScreenName('');
    setTicketGrade('');
    setTicketCount(0);
  };
  const _changeTime = (e) => {
    const ticketTimeCode = parseInt(e.target.value);
    const ticketTimeName = e.target.options[e.target.selectedIndex].text;

    _getScreenInfo(ticketTimeCode);

    setTicketTimeCode(ticketTimeCode);
    setTicketTimeName(ticketTimeName);

    setTicketSumPrice(0);
    setSeatNumber(0);
    setRemainSeat(0);

    setTicketScreenCode('');
    setTicketScreenName('');
    setTicketGrade('');
    setTicketCount(0);
    //상영관 정보.
  };
  const _changeScreen = async (e) => {
    const index = e.target.selectedIndex;
    const ticketScreenCode = e.target.value;
    const ticketScreenName = e.target.options[index].text;

    const result = await axios.post(`${apiUrl}/seatReserveGetRemainSeat`, {
      ticketCode,
      ticketDateCode,
      ticketTimeCode,
      ticketScreenCode,
    });

    const intReturn = result.data[0].intReturn;
    const cnt = result.data[0].cnt;
    // console.log(cnt);
    //console.log(index);
    if (intReturn === 0) {
      if (cnt <= 0) {
        alert('전 좌석 매진되었습니다. 성원에 감사드립니다.');
      } else {
        setSeatNumber(screenInfo[index - 1].seatNumber);
        // setRemainSeat(
        //   screenInfo[index - 1].seatNumber - screenInfo[index - 1].cnt
        // );

        setRemainSeat(cnt);
        setTicketScreenCode(ticketScreenCode);
        setTicketScreenName(ticketScreenName);
        setTicketCount(0);
        setTicketSumPrice(0);
        setTicketGrade('');
      }
    } else {
      alert('예매 좌석이 존재하지 않습니다.');
    }

    //남은 수량 체크(매진여부 확인)
  };

  const _changeCount = (e) => {
    const ticketCount = parseInt(e.target.value);
    setTicketCount(ticketCount);
    if (ticketGrade === 'S') {
      setTicketSumPrice(ticketCount * ticketPrice);
      // } else if (ticketGrade === 'S') {
      //   setTicketSumPrice(ticketCount * ticketPrice + ticketCount * 5000);
    } else {
      setTicketSumPrice(ticketCount * (ticketPrice - 50000));
    }
  };
  const _changeGrade = (e) => {
    const ticketGrade = e.target.value;
    setTicketGrade(ticketGrade);
  };
  const _changePaymethod = (e) => {
    const payType = e.target.value;
    setPayType(payType);
  };

  const _onReserve = () => {
    // console.log(ticketInfo[0].reserveStartDate);
    if (!ticketCode) {
      alert('티켓판매가 활성화 되지 않았습니다.');
      return null;
    }
    if (ticketDateCode === 0) {
      alert('일자를 선택해 주세요.');
      return null;
    }
    if (ticketTimeCode === 0) {
      alert('시간을 선택해 주세요.');
      return null;
    }

    if (ticketScreenCode === '') {
      alert('상영관을 선택해 주세요.');
      return null;
    }

    // 선택사항
    if (ticketGrade === '') {
      console.log(ticketGrade);
      alert('좌석 등급을 선택해 주세요.');
      return null;
    }
    if (ticketCount === 0) {
      alert('좌석수를 선택해 주세요.');
      return null;
    }
    if (payType === '') {
      alert('결제방식을 선택해 주세요.');
      return null;
    }
    document
      .querySelector('#reserveContain')
      .scrollIntoView({ block: 'start', behavior: 'smooth' });
    // document.getElementById('reserveContain').scrollTo(0, 0);
    // setTimeout(() => {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth',
    //   });
    // }, 700);

    setStep(2);

    const data = {
      ui: loginId,
      ticketCode: ticketCode,
      rdate: ticketDateCode,
      rtime: ticketTimeCode,
      room: ticketScreenCode,
      seatCount: ticketCount,
      ticketGrade: ticketGrade,
    };

    initSocket(ticketTimeCode);

    socket.emit('login', data);
  };

  const _onPayment = async () => {
    // const cKey = 'test_ck_qLlDJaYngrooqgwBpNmrezGdRpXx';
    const cKey = 'live_ck_d26DlbXAaV0P42ERJN0VqY50Q9RB';
    if (mySeats.length <= 0) {
      alert('예매할 좌석을 선택해 주세요');
      return null;
    }
    const selectSeat = mySeats.split(',');
    if (step !== 2) {
      alert('잘못된 접근입니다.');
      return null;
    }
    if (parseInt(ticketCount) > parseInt(selectSeat.length)) {
      alert(
        `${
          parseInt(ticketCount) - parseInt(selectSeat.length)
        }의 좌석을 더 선택해 주세요`
      );
      return null;
    }

    const orderCode = _makeOrderCode();
    const toasspayments = await loadTossPayments(cKey);
    const orderName = `${ticketInfo[0].title} ${ticketCount} 장 티켓 예매`;

    const result = await axios.post(apiUrl + '/seatReservePaymentPre', {
      orderCode,
      userid: loginId,
      ticketCode,
      rdate: ticketDateCode,
      rtime: ticketTimeCode,
      room: ticketScreenCode,
      payLocation: isMobile ? 'M' : 'W',
      ticketGrade: ticketGrade,
    });

    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      if (
        payType === '네이버페이' ||
        payType === '카카오페이' ||
        payType === '토스페이'
      ) {
        // setPayPopup(true);
        // const width = 500;
        // const height = 400;

        // const left = window.screenX + (window.outerWidth - width) / 2;
        // const top = window.screenY + (window.outerHeight - height) / 2;
        // const popup = window.open(
        //   `/seatReservePay?o=${orderCode}&a=${ticketSumPrice}&n=${orderName}&t=${payType}`,
        //   '결제 중...',
        //   `width=${width},height=${height},left=${left},top=${top}`
        // );

        // console.log(ticketSumPrice, orderCode, orderName, loginId, payType);
        await toasspayments.requestPayment('간편결제', {
          amount: ticketSumPrice,
          orderId: orderCode,
          orderName: orderName,
          customerName: loginId,
          successUrl: `${window.location.origin}/seatSucc`,
          // successUrl: `http://son.aniplustv.com:4000/paySucc`,
          failUrl: `${window.location.origin}/seatFail`,
          flowMode: 'DIRECT',
          easyPay: payType,
        });
      } else {
        // window.open(
        //   `/seatPop?a=${ticketSumPrice}&i=${orderCode}&n=${orderName}&c=${loginId}`,
        //   '',
        //   'width=500, height=500'
        // );
        await toasspayments.requestPayment(payType, {
          amount: ticketSumPrice,
          orderId: orderCode,
          orderName: orderName,
          customerName: loginId,
          // successUrl: `http://son.aniplustv.com:4000/paySucc`,
          successUrl: `${window.location.origin}/seatSucc`,
          failUrl: `${window.location.origin}/seatFail`,
          // variantKey: "DEFAULT",
        });
      }
    } else if (intReturn === -2) {
      alert('결제할 예매 좌석이 존재하지 않습니다.');
    } else if (intReturn === -1) {
      alert('결제중 오류가 발생했습니다.');
    } else if (intReturn === -3) {
      alert('판매중인 티켓이 아닙니다.');
    }
  };

  const handleReserveSeat = (indexY, indexX, seatName) => {
    // console.log(indexX, indexY);
    if (isLoggedIn) {
      const data = {
        ticketCode: ticketCode,
        x: indexX,
        y: indexY,
        ui: Base64.encode(loginId),
        rdate: ticketDateCode,
        rtime: ticketTimeCode,
        room: ticketScreenCode,
        seatName: seatName,
        seatCount: ticketCount,
      };
      socket.emit('reserveSeat', data);
    } else {
      alert('Please log in first');
    }
  };

  const _getSeatColor = (seat) => {
    // console.log(seat);
    let className = '';
    switch (parseInt(seat.r)) {
      case 0:
        className = 'seat no_color';
        break;
      case 1:
        className = 'seat white_color';
        break;
      case 2:
        className = 'seat grey_color';
        break;
      case 3:
        className = 'seat black_color';
        break;
      case 4:
        className = 'seat no_color1';
        break;
      case 5:
        className = 'seat gray_color2';
        break;
      default:
        className = 'seat';
        break;
    }
    if (seat.r === 3 && seat.i === Base64.encode(loginId)) {
      className = 'seat red_color';
    }
    if (seat.r === 2 && seat.i === Base64.encode(loginId)) {
      className = 'seat orange_color';
    }
    return className;
  };

  function formatSecondsToTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(
      2,
      '0'
    )}`;
    // const minutes = Math.floor(seconds / 60);
    // const remainingSeconds = seconds % 60;

    // const formattedMinutes = String(minutes).padStart(2, '0');
    // const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    // setMm(formattedMinutes);
    // setSs(formattedSeconds);
    // return `${formattedMinutes}:${formattedSeconds}`;
  }

  const _timerUpdate = ({ time, duration }) => {
    // console.log(time, duration);
    const gap = duration - time;

    const mm = String(Math.floor((gap / (1000 * 60)) % 60)).padStart(2, '0'); // 분
    const ss = String(Math.floor((gap / 1000) % 60)).padStart(2, '0'); // 초

    setMm(mm);
    setSs(ss);
  };

  const _popupClose = () => {
    setListShow(false);
  };
  const _popupShow = () => {
    setListShow(true);
  };

  const _timerFinish = () => {
    setMm('');
    setSs('');
    worker.terminate();
    leaveReservation();
    if (socket) {
      socket.off('seatStatus');
      socket.off('loginFailed');
      socket.off('reservationFailed');
      socket.off('seatSuccess');
      socket.off('disconnectUpdate');
      socket.off('seatUpdate');
      socket.off('payUpdate');
      socket.off('cancelUpdate');
      socket.disconnect();
    }
    // if (step === 1) {
    setTimeout(() => {
      window.location.replace('/event/352');
    }, 500);

    // } else {
    // window.location.reload();
    // }
  };
  const _makeOrderCode = () => {
    let date = new Date();
    let f = 'a';
    let m = 1;
    let arr =
      '0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z'.split(
        ','
      );
    let newarr = new Array(m);
    let tmp = '';
    let flag = false;
    for (let i = 0; i < m; i++) {
      tmp = '';
      flag = false;
      for (let j = 0; j < 7; j++) {
        tmp += arr[Math.floor(Math.random() * arr.length)];
      }
      for (let k = 0; k < i; k++) {
        if (newarr[k] == f + tmp) {
          flag = true;
          i--;
          break;
        }
      }
      if (!flag) newarr[i] = f + tmp;
    }
    let temp = moment(date).format('YYYYMMDDhhmmss');

    return temp + '_' + loginId.substring(0, 4) + '_' + newarr[0];
  };
  const unload = async () => {
    // console.log('SeatReserve unload.....');
    worker.terminate();
    leaveReservation();
    if (socket) {
      socket.off('seatStatus');
      socket.off('loginFailed');
      socket.off('reservationFailed');
      socket.off('seatSuccess');
      socket.off('disconnectUpdate');
      socket.off('seatUpdate');
      socket.off('payUpdate');
      socket.off('cancelUpdate');
      socket.disconnect();
    }
  };

  const unloadMobile = async () => {
    // console.log('SeatReserve unload.....');

    worker.terminate();
    leaveReservation();
    if (socket) {
      socket.off('seatStatus');
      socket.off('loginFailed');
      socket.off('reservationFailed');
      socket.off('seatSuccess');
      socket.off('disconnectUpdate');
      socket.off('seatUpdate');
      socket.off('payUpdate');
      socket.off('cancelUpdate');
      socket.disconnect();
    }
    alert(
      '모바일 기기의 화면이 OFF 되었거나 다른 탭으로 이동하여 애매가 취소되었습니다.'
    );
    setTimeout(() => {
      window.location.replace('/event/352');
    }, 300);
  };

  useEffect(() => {
    document.oncontextmenu = function () {
      return false;
    };
    let interval;

    if (loginId === null || loginId === undefined || loginId === '') {
      alert('로그인후 이용해주세요.');
    } else {
      _getInfo();
      setIsLoggedIn(true);

      const blob = new Blob(
        [
          `
        let timerId = null;
        self.onmessage = function(e) {
          const { duration } = e.data;
          const start = Date.now();
          const end = start + duration * 1000;

          timerId = setInterval(() => {
            const now = Date.now();
            const remaining = Math.max(0, Math.floor((end - now) / 1000));
            self.postMessage({ remaining });
            if (remaining <= 0) {
              clearInterval(timerId);
            }
          }, 1000);
        };
      `,
        ],
        { type: 'application/javascript' }
      );
      worker = new Worker(URL.createObjectURL(blob));

      worker.postMessage(
        loginId === 'admin' || loginId === 'aniplus'
          ? { duration: 20 * 60 }
          : { duration: 5 * 60 }
      ); // 5분

      worker.onmessage = (e) => {
        const { remaining } = e.data;
        // console.log(remaining);

        setRemainingTime(remaining);
        if (remaining === 0) {
          _timerFinish();
        }
      };

      // initSocket();
    }
    window.addEventListener('beforeunload', unload);
    if (isMobile) {
      document.addEventListener('visibilitychange', unloadMobile);
      // window.addEventListener('pagehide', unloadMobile);
    }

    // window.addEventListener('pagehide', unload);
    // window.addEventListener('unload', unload);
    return () => {
      // console.log('disconnect.......');
      worker.terminate();
      leaveReservation();
      if (socket) {
        // console.log('socket disconnect');
        socket.off('seatStatus');
        socket.off('loginFailed');
        socket.off('reservationFailed');
        socket.off('seatSuccess');
        socket.off('disconnectUpdate');
        socket.off('seatUpdate');
        socket.off('payUpdate');
        socket.off('cancelUpdate');
        socket.disconnect();
      }
      // window.removeEventListener('unload', unload);
      window.removeEventListener('beforeunload', unload);
      // window.removeEventListener('pagehide', unload);
      if (isMobile) {
        document.removeEventListener('visibilitychange', unloadMobile);
        // window.removeEventListener('pagehide', unloadMobile);
      }
    };
  }, []);
  return (
    <>
      <div className="overlay" style={{ display: payPopup ? 'block' : 'none' }}>
        결제 중...
      </div>
      <div className="yemae_container">
        {/* {step === 1 || step === 2 ? (
          <Timer
            active={true}
            duration={timerDuration}
            onTimeUpdate={_timerUpdate}
            onFinish={_timerFinish}
          />
        ) : null} */}

        <div className="title_name">
          {isMobile ? '' : '예매하기 : '}{' '}
          <span>{ticketInfo.length > 0 && ticketInfo[0].title}</span>
        </div>
        <div className="yemae_content">
          <div className="padding_content">
            <div
              id="reserveContain"
              style={{
                backgroundImage: `url(/img/seat/${
                  ticketInfo.length > 0 && ticketInfo[0].bgImg
                })`,
              }}
            >
              <div className="position_content">
                <div className="user_info_div">
                  <dl>
                    <dt>
                      <span>
                        <img
                          src={
                            userInfo.length > 0 ? userInfo[0].charac_img : ''
                          }
                        />
                      </span>
                      <em></em>
                    </dt>
                    <dd>
                      <span>{nicName}</span>
                      <em>
                        {step === 1
                          ? '원하시는 티켓옵션을 선택해 주세요'
                          : '에매할 좌석을 선택해 주세요'}
                      </em>
                    </dd>
                  </dl>
                </div>

                <>
                  <div className="my_yemae_btn">
                    <a onClick={_popupShow}>
                      나의 예매 내역
                      <em>{userInfo.length > 0 && userInfo[0].cnt}</em>
                    </a>
                  </div>
                  <div className="time_div1">
                    <span>예매 남은시간</span>
                    <em>
                      {formatSecondsToTime(remainingTime)}
                      {/* {mm}:{ss} */}
                    </em>
                  </div>
                </>

                <table
                  width="100%"
                  border="0"
                  cellSpacing="0"
                  cellPadding="0"
                  className="table_box"
                >
                  <tbody>
                    <tr>
                      <td valign="top" className="jali_div">
                        {step === 1 ? (
                          <div className="yemae_seontaeg_div">
                            <dl>
                              <div className="ticket-notice">
                                ※ 옵션을 선택한 후 좌석 예매페이지로 이동 시
                                선택된 옵션의 변경은 불가하므로 상영시간,
                                좌석수, 결제방식등을 가급적 신중히 선택하여
                                원활한 예약을 진행하시길 바랍니다.
                              </div>
                            </dl>
                            <dl>
                              <dt>일자</dt>
                              <dd>
                                <select
                                  id="date"
                                  name=""
                                  className="common_select select_bg2"
                                  onChange={_changeDate}
                                  value={ticketDateCode}
                                >
                                  <option value={0}>선택</option>
                                  {ticketInfo &&
                                    ticketInfo.map((item) => (
                                      <option
                                        value={item.ticketDateCode}
                                        key={item.ticketDateCode}
                                      >
                                        {item.ticketDateName}
                                      </option>
                                    ))}
                                </select>
                              </dd>
                            </dl>
                            <dl>
                              <dt>시간</dt>
                              <dd>
                                <select
                                  id="time"
                                  name=""
                                  className="common_select select_bg2"
                                  onChange={_changeTime}
                                  value={ticketTimeCode}
                                >
                                  <option value={0}>선택</option>
                                  {timeInfo &&
                                    timeInfo.map((item) => (
                                      <option
                                        value={item.ticketTimeCode}
                                        key={item.ticketTimeCode}
                                      >
                                        {item.ticketTimeName}
                                      </option>
                                    ))}
                                </select>
                              </dd>
                            </dl>
                            <dl>
                              <dt>상영관</dt>
                              <dd>
                                <select
                                  id="room"
                                  name=""
                                  className="common_select select_bg2"
                                  onChange={_changeScreen}
                                  value={ticketScreenCode}
                                >
                                  <option value="0">선택</option>
                                  {screenInfo &&
                                    screenInfo.map((item) => (
                                      <option
                                        value={`${item.ticketScreenCode}`}
                                        key={item.ticketScreenCode}
                                      >
                                        {item.ticketScreenName}
                                        {/* {item.seatNumber - item.cnt < 10
                                          ? `(${
                                              item.seatNumber - item.cnt
                                            }남음)`
                                          : null} */}
                                      </option>
                                    ))}
                                </select>
                              </dd>
                              <dl>
                                <dt>좌석등급</dt>
                                <dd>
                                  <select
                                    id="ticketGrade"
                                    name=""
                                    className="common_select select_bg2"
                                    onChange={_changeGrade}
                                    value={ticketGrade}
                                  >
                                    <option value="">선택</option>
                                    <option value="S">
                                      스페셜(전달회 포함)
                                    </option>
                                    <option value="N">
                                      베이직(전달회 미포함)
                                    </option>
                                  </select>
                                </dd>
                              </dl>
                              <dl>
                                <dt>좌석수</dt>
                                <dd>
                                  <select
                                    id="seatCount"
                                    name=""
                                    className="common_select select_bg2"
                                    onChange={_changeCount}
                                    value={ticketCount}
                                  >
                                    {remainSeat >= 4 ? (
                                      <>
                                        <option value={0}>선택</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                      </>
                                    ) : (
                                      <>
                                        <option value={0}>선택</option>
                                        {Array(remainSeat)
                                          .fill(null)
                                          .map((_, index) => (
                                            <option value={index + 1}>
                                              {index + 1}
                                            </option>
                                          ))}
                                      </>
                                    )}
                                  </select>
                                </dd>
                              </dl>
                              <dl>
                                <dt>결제방식</dt>
                                <dd>
                                  <select
                                    name=""
                                    className="common_select select_bg2"
                                    onChange={_changePaymethod}
                                    value={payType}
                                  >
                                    <option value={''}>선택</option>
                                    <option value={'카드'}>카드</option>
                                    <option value={'계좌이체'}>계좌이체</option>
                                    {/* <option value={'네이버페이'}>
                                      네이버페이
                                    </option> */}
                                    <option value={'카카오페이'}>
                                      카카오페이
                                    </option>
                                    <option value={'토스페이'}>토스페이</option>
                                  </select>
                                </dd>
                              </dl>
                            </dl>
                          </div>
                        ) : (
                          <div
                            className="seatContainer"
                            style={{ minHeight: 700 }}
                          >
                            <div className="jali_title_name">SCREEN</div>
                            <div className="jali_box_div">
                              {seats.map((item, indexY) => (
                                <div className="line_div" key={indexY}>
                                  {item.map((seat, indexX) => (
                                    <div
                                      key={indexX}
                                      //style={{
                                      //width: '3.5%',
                                      //   height: '40px',
                                      //}}
                                      data-id=""
                                      data-x={indexX}
                                      data-y={indexY}
                                      className={_getSeatColor(seat)}
                                      onClick={() =>
                                        handleReserveSeat(
                                          indexY,
                                          indexX,
                                          seats[indexY][indexX].n
                                          // _getSeatName(
                                          //   ticketScreenCode,
                                          //   indexY,
                                          //   indexX
                                          // )
                                        )
                                      }
                                    >
                                      {seats[indexY][indexX].n}
                                      {/* {_getSeatName(
                                      ticketScreenCode,
                                      indexY,
                                      indexX
                                    )} */}
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </div>

                            <div className="jali_color">
                              <span className="red_color"></span>
                              <em>나의 예매완료 좌석</em>
                              <span className="orange_color"></span>
                              <em>나의 선택 좌석</em>
                              <span className="white_color"></span>
                              <em>예매가능 좌석</em>
                              <span className="grey_color"></span>
                              <em>다른 사용자 예매중</em>
                              <span className="black_color"></span>
                              <em>예매완료 좌석</em>
                              <span className="grey_color2"></span>
                              <em>예매불가 좌석</em>
                            </div>
                          </div>
                        )}
                        {step === 1 ? (
                          <div className="yuuisahang">
                            <dl>
                              {isMobile ? (
                                <dd>유의 사항</dd>
                              ) : (
                                <dt>유의 사항</dt>
                              )}
                              <dd>
                                1. 티켓 구매 중{' '}
                                <span style={{ color: 'red' }}>새로고침</span>{' '}
                                또는 <span style={{ color: 'red' }}>F5</span>{' '}
                                키를 누르지 마세요. 모든 데이터가 초기화
                                됩니다.{' '}
                              </dd>
                              <dd>
                                2. 모바일 브라우져에서{' '}
                                <span style={{ color: 'red' }}>
                                  다른 탭으로 이동하거나 휴대폰 화면을 OFF
                                </span>{' '}
                                하게 되면 모든 데이터가 초기화 됩니다.
                              </dd>
                              <dd>
                                3. 티켓 판매 페이지에는{' '}
                                <span style={{ color: 'red' }}>
                                  중복 접속이 불가
                                </span>
                                합니다.(한 아이디로 두번 접속 불가능)
                              </dd>
                              <dd>
                                4.{' '}
                                <span style={{ color: 'red' }}>
                                  예매 제한시간내(5분)
                                </span>{' '}
                                결제가 완료되지 않으면 모든 데이터는 초기화
                                됩니다.
                              </dd>
                              <dd>
                                5. 티켓 예매는 2026년 4월 8일 오후 5시부터
                                2026년 4월 14일 오후 5시까지 가능합니다.
                              </dd>
                              <dd>
                                6. 티켓 취소는 2026년 4월 8일 오후 5시부터
                                2026년 4월 13일 오후 5시까지 가능합니다.
                              </dd>
                              <dd>
                                7. QR(바)코드 발송은 회원정보에 등록된
                                휴대폰번호로 발송되오니 회원정보의 휴대폰번호를
                                필히 확인해 주세요.(발송일자 : 4월 16일)
                              </dd>
                              <dd>
                                8.{' '}
                                <span style={{ color: 'red' }}>
                                  모바일의 카카오톡 브라우져
                                </span>
                                의 경우 정상적으로{' '}
                                <span style={{ color: 'red' }}>
                                  예매가 불가
                                </span>
                                합니다.
                              </dd>
                              <dd>
                                9.{' '}
                                <span style={{ color: 'red' }}>
                                  모바일의 네이버앱 브라우져
                                </span>
                                의 경우 정상적으로{' '}
                                <span style={{ color: 'red' }}>
                                  예매가 불가
                                </span>
                                합니다.
                              </dd>

                              <dd>
                                10.{' '}
                                <span style={{ color: 'red' }}>
                                  iOS 11이상의 버젼에서 보안 강화로 인하여
                                  정상적으로 결제가 이루어 지지 않을 수
                                  있습니다. 결제전 필히 아래와 같이 사파리
                                  설정을 확인해주세요
                                </span>
                              </dd>
                              <dd>
                                <span style={{ color: 'red' }}>
                                  설정 &gt; Safari &gt; [크로스 사이트 추적방지
                                  -&gt; 미사용] [모든 쿠키 차단 -&gt; 미사용]
                                  [위조된 웹사이트 경고 -&gt; 미사용] [데스크탑
                                  웹 사이트 요청 &gt; 모든 사이트 -&gt; 사용]
                                </span>
                              </dd>
                              <dd></dd>
                            </dl>
                          </div>
                        ) : null}
                      </td>
                      <td className="info_div">
                        {isMobile ? null : (
                          <div
                            className="movie_img"
                            // style="background-image:url(/img/seat/movie_img.jpg);"
                          >
                            <img
                              src={`/img/seat/${
                                ticketInfo.length > 0 ? ticketInfo[0].img : null
                              }`}
                            />
                          </div>
                        )}

                        <div className="movie_info">
                          <h2>{nicName}님 예매내역</h2>
                          <ul>
                            <li>
                              <span>장소</span>
                              <em className="color_text1">
                                {ticketInfo.length > 0 && ticketInfo[0].loc}
                              </em>
                            </li>
                            <li>
                              <span>일자</span>
                              <em>{ticketDateName}</em>
                            </li>
                            <li>
                              <span>시간</span>
                              <em>{ticketTimeName}</em>
                            </li>
                            <li>
                              <span>상영관</span>
                              <em>{ticketScreenName}</em>
                            </li>
                            {step === 1 ? (
                              <>
                                <li>
                                  <span>총좌석</span>
                                  <em>{seatNumber}</em>
                                </li>
                                <li>
                                  <span>잔여좌석</span>
                                  <em>{remainSeat}</em>
                                </li>
                              </>
                            ) : (
                              <>
                                <li>
                                  <span>선택좌석</span>
                                  <em>{mySeats}</em>
                                </li>
                              </>
                            )}

                            <li>
                              <span>티켓</span>
                              <em className="color_text2">
                                {ticketCount}{' '}
                                {ticketGrade === 'N'
                                  ? '(베이직-전달회 미포함)'
                                  : ticketGrade === 'S'
                                    ? '(스페셜-전달회 포함)'
                                    : ''}
                              </em>
                            </li>
                            <li>
                              <span>결제방식</span>
                              <em className="color_text2">{payType}</em>
                            </li>
                          </ul>
                          <div className="gumae_info">
                            <dl>
                              <dt>총 결제금액</dt>
                              <dd>
                                {ticketSumPrice.toLocaleString('ko-KR')}원
                              </dd>
                            </dl>
                            <a onClick={step === 1 ? _onReserve : _onPayment}>
                              {step === 1 ? '예매하기' : '결제하기'}
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={listShow}
        showCloseIcon={false}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        center
        styles={{
          modal: {
            backgroundColor: 'black',
          },
        }}
      >
        <SeatReserveMy
          ticketCode={ticketCode}
          charImg={userInfo.length > 0 ? userInfo[0].charac_img : icon}
          popupClose={_popupClose}
          // socket={socket}
        />
      </Modal>
    </>
  );
};
export default shopContext(withRouter(SeatReserve));
